import ReactInputMask from "react-input-mask"
import React from "react"
import {TIME_FORMAT} from "../../utils/constants"
import PropTypes from "prop-types"
import {TextField} from "@mui/material"

const TimerInput = ({ value = "", onChange, ...props }) => {
    const handleChange = (e) => onChange(e.target.value)

    return (
        <ReactInputMask
            mask={TIME_FORMAT}
            value={value}
            onChange={handleChange}
            maskChar=""
        >
            {(inputMaskProps) => (
                <TextField
                    {...inputMaskProps}
                    {...props}
                    fullWidth
                    type="text"
                    value={value}
                    onChange={handleChange}
                    label={"Hora"}
                    focused
                />
            )}
        </ReactInputMask>
    )
}

TimerInput.propTypes = {
    props: PropTypes.object,
    value: PropTypes.string,
    onChange: PropTypes.func.isRequired,
}

export default TimerInput